module.exports = __webpack_public_path__ + "static/media/student-score-point-bg.d3c06f4f.png";